import { render, staticRenderFns } from "./DeliveryEvent.vue?vue&type=template&id=33757860&scoped=true&"
import script from "./DeliveryEvent.vue?vue&type=script&lang=js&"
export * from "./DeliveryEvent.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryEvent.vue?vue&type=style&index=0&id=33757860&lang=sass&scoped=true&"
import style1 from "./DeliveryEvent.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33757860",
  null
  
)

export default component.exports